var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonAddOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6246 7.12354C17.4408 9.60182 15.5621 11.6235 13.4995 11.6235C11.437 11.6235 9.55502 9.60229 9.37455 7.12354C9.18705 4.54541 11.0152 2.62354 13.4995 2.62354C15.9839 2.62354 17.8121 4.59229 17.6246 7.12354Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5005 14.6235C9.42239 14.6235 5.28333 16.8735 4.51739 21.1204C4.42364 21.6323 4.71473 22.1235 5.25098 22.1235H21.7505C22.2868 22.1235 22.5765 21.6323 22.4841 21.1204C21.7177 16.8735 17.5786 14.6235 13.5005 14.6235Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 8.62354V13.8735M6.75 11.2485H1.5",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonAddOutline);
export default __webpack_public_path__ + "static/media/person-add-outline.9bfd395724f0c5313d0bb200f43f40db.svg";
export { ForwardRef as ReactComponent };